// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5173":"51b86561","6085":"06d65d86"}[chunkId] + ".chunk.css";
};